import {IWorkspace} from '../../models';

const _sortWorkspaceFn = (a: IWorkspace, b: IWorkspace) => {
  const keyA = ((a.organization.name || '') + '_' + a.name).toLowerCase();
  const keyB = ((b.organization.name || '') + '_' + b.name).toLowerCase();

  if (keyA > keyB) {
    return 1;
  } if (keyA < keyB) {
    return -1;
  }
  return 0;
}

export const sortWorkspaces = (workspaces: IWorkspace[]) => {
  if (!workspaces) {
    return [];
  }

  return workspaces.sort(_sortWorkspaceFn);
}
